module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAK1JREFUKFOdkrENwjAURN+vKGEUNsCZAJiA0IaKSaigJUwA2cDeIKM4ZaqPQmxkIQIBV6fvu6/znYXk6JEcYYMyf4yFGiil4BJp0gE9MGPCFTDpggRbWtayx/eCExZYDJDj2EpBJsHG+Qu5v1a2MnJ73Oc6gQemLDtXClXGIFb8iwCoTBC8wdD8YanPfvyjf4jVSYFJi7t96MLRsnoWFzMLneQQvgbUKKXsKCPnDtLSRafQ2C4RAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_more.png
// module id = wScn
// module chunks = 1